export default {
  AvailableStartTime: 'شروع اعتبار',
  AvailableStartTimeMin: 'شروع اعتبار از',
  AvailableStartTimeMax: 'شروع اعتبار تا',
  AvailableExpireTime: 'پایان اعتبار',
  AvailableExpireTimeMin: 'پایان اعتبار از',
  AvailableExpireTimeMax: 'پایان اعتبار تا',
  CashAmount: 'اعتبار نقدی',
  CommandNumber: 'شماره دستور',
  CommandTime: 'تاریخ دستور',
  CommandTimeMin: 'تاریخ دستور از',
  CommandTimeMax: 'تاریخ دستور تا',
  CompanyDiscountAmount: 'تخفیف باربری',
  CompanyDiscountAmountMin: 'تخفیف باربری تا',
  CompanyDiscountAmountMax: 'تخفیف باربری از',
  CompanyDiscountTypeId: 'نوع تخفیف باربری',
  CarModelFeatures: 'نوع خودرو',
  Coupones: 'کوپن',
  Companies: 'باربری‌ها',
  CarModels: 'خانواده خودرو',
  CarLoads: 'بارگیر',
  Employees: 'افراد',
  Addons: 'خدمات جانبی',
  ItemGroups: 'گروه اقلام',
  Items: 'نوع اقلام',
  ItemsFeature: 'خانواده اقلام',
  Loads: 'نوع بار',
  Packages: 'بسته بندی',
  Enabled: 'فعال',
  ExcludePromotion: 'عدم شمول روی پیشنهاد ویژه',
  ExcludeCampaign: 'عدم شمول روی کمپین ها',
  FirstOrder: 'مخصوص سفارش اول',
  GiftAmount: 'اعتبار هدیه',
  MaximumUse: 'حداکثر تعداد قابل استفاده',
  MaximumUseMin: 'حداکثر تعداد قابل استفاده از',
  MaximumUseMax: 'حداکثر تعداد قابل استفاده تا',
  Keywords: 'کلمات کلیدی',
  companyDiscountAmount: 'مقدار تخفیف باربری',
  MaximumCompanyDiscountAmount: 'حداکثر مقدار تخفیف باربری',
  MaximumCompanyDiscountAmountMin: 'حداکثر مقدار تخفیف باربری از',
  MaximumCompanyDiscountAmountMax: 'حداکثر مقدار تخفیف باربری تا',
  MarketplaceDiscountAmount: 'تخفیف باربانت',
  MarketplaceDiscountAmountMin: 'تخفیف باربانت از',
  MarketplaceDiscountAmountMax: 'تخفیف باربانت تا',
  MaximumMarketplaceDiscountAmount: 'حداکثر مقدار تخفیف باربانت',
  MaximumMarketplaceDiscountAmountMin: 'حداکثر مقدار تخفیف باربانت از',
  MaximumMarketplaceDiscountAmountMax: 'حداکثر مقدار تخفیف باربانت تا',
  MinimumOrderAmount: 'حداقل مبلغ سفارش',
  MinimumOrderAmountMin: 'حداقل مبلغ سفارش از',
  MinimumOrderAmountMax: 'حداقل مبلغ سفارش تا',
  MarketplaceDiscountTypeId: 'نوع تخفیف باربانت',
  Organization: 'سازمان',
  Title: 'عنوان',
  Percent: 'درصد',
  Reusable: 'چند بار مصرف',
  Pin: 'پین',
  PinLength: 'طول پین',
  Quantity: 'تعداد',
  ShowAndroid: 'نمایش در اندروید',
  ShowIOS: 'نمایش در ios',
  ShowWeb: 'نمایش در وب',
  ShowWebService: 'نمایش در وب سرویس',
  SortOrder: 'ترتیب نمایش',
  ShowOn: 'نمایش در',
  Slug: 'Slug',
  Used: 'استفاده شده',
  discountCouponType: 'نوع کوپن تخفیف',
  discountCoupons: 'کوپن های تخفیف',

  commandNumber: 'شماره دستور',
  companyDiscountAmount: 'تخفیف باربری',
  marketplaceDiscountAmount: 'تخفیف باربانت',
  maximumMarketplaceDiscountAmount: 'حداکثر مقدار تخفیف باربانت',
  maximumCompanyDiscountAmount: 'حداکثر مقدار تخفیف باربری',
  minimumOrderAmount: 'حداقل مبلغ سفارش',
  maximumUse: 'حداکثر تعداد قابل استفاده',
  reusable: 'چند بار مصرف',
  firstOrder: 'مخصوص سفارش اول',
  excludePromotion: 'عدم شمول روی پیشنهاد ویژه',
  excludeCampaign: 'عدم شمول روی کمپین ها',
  showWeb: 'نمایش در وب',
  showAndroid: 'نمایش در اندروید',
  showIOS: 'نمایش در ios',
  showWebService: 'نمایش در وب سرویس',
  marketplaceDiscountTypeId: 'نوع تخفیف باربانت',
  companyDiscountTypeId: 'نوع تخفیف باربری',
  availableStartTime: 'شروع اعتبار',
  availableExpireTime: 'پایان اعتبار',
  keywords: 'کلمات کلیدی',
  companies: 'باربری‌ها',
  carModels: 'خانواده خودرو',
  carModelFeatures: 'نوع خودرو',
  carLoads: 'بارگیر',
  employees: 'افراد',
  itemGroups: 'گروه اقلام',
  items: 'نوع اقلام',
  itemsFeature: 'خانواده اقلام',
  loads: 'نوع بار',
  packages: 'بسته بندی',
  organization: 'سازمان',

  cashAmount: 'اعتبار نقدی',
  giftAmount: 'اعتبار هدیه',
  commandTime: 'تاریخ دستور',
  showOn: 'نمایش در',
  coupon: 'کوپن',
  used: 'استفاده شده',
  pin: 'پین',
  quantity: 'تعداد',

  deadlineTime: 'مهلت درج',
  minimumMarketplaceDiscount: 'حداقل مقدار تخفیف باربانت',
  maximumMarketplaceDiscount: 'حداکتر مقدار تخفیف باربانت',
  minimumCompanyDiscount: 'حداقل مقدار تخفیف باربری',
  maximumCompanyDiscount: 'حداکثر مقدار تخفیف باربری',
  pinLength: 'طول پین'
}
